import { render, staticRenderFns } from "./TasksMadeClosure.vue?vue&type=template&id=67f76082&scoped=true"
import script from "./TasksMadeClosure.vue?vue&type=script&lang=js"
export * from "./TasksMadeClosure.vue?vue&type=script&lang=js"
import style0 from "./TasksMadeClosure.vue?vue&type=style&index=0&id=67f76082&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f76082",
  null
  
)

export default component.exports